module.exports = __webpack_public_path__ + "img/17390475.4c7a6fd2.png";